import { render, staticRenderFns } from "./AttendanceDetails.vue?vue&type=template&id=4c7ffcfa&scoped=true"
import script from "./AttendanceDetails.vue?vue&type=script&lang=js"
export * from "./AttendanceDetails.vue?vue&type=script&lang=js"
import style0 from "./AttendanceDetails.vue?vue&type=style&index=0&id=4c7ffcfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7ffcfa",
  null
  
)

export default component.exports